import { render, staticRenderFns } from "./photoLabel.vue?vue&type=template&id=b1e4517c&scoped=true"
import script from "./photoLabel.vue?vue&type=script&lang=js"
export * from "./photoLabel.vue?vue&type=script&lang=js"
import style0 from "./photoLabel.vue?vue&type=style&index=0&id=b1e4517c&prod&lang=scss&scoped=true"
import style1 from "./photoLabel.vue?vue&type=style&index=1&id=b1e4517c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e4517c",
  null
  
)

export default component.exports